import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
/* Constants */
import { SELL_IT_YOURSELF, SELLING_METHODS } from 'client/site-modules/shared/constants/private-party/private-party';
import { APPRAISAL_VEHICLE_ENTRY_CREATIVE_ID } from 'site-modules/shared/constants/appraisal/appraisal';
import { PRIVATE_PARTY_EVENTS } from 'site-modules/shared/constants/private-party/private-party-events';
/* Utils */
import { EventToolbox } from 'client/utils/event-toolbox';
/* Components */
import { RadioList } from 'site-modules/shared/components/radio-list/radio-list';

import './selling-methods-module.scss';

export function SellingMethodsModule({ handleBtnViewChange = noop }) {
  const [checkedMethod, setCheckedMethod] = useState('');

  const handleChange = useCallback(e => {
    const value = e.target.value;
    setCheckedMethod(value);
    EventToolbox.fireCustomEvent(PRIVATE_PARTY_EVENTS.SELECT_SELLING_METHOD, {
      creativeId: APPRAISAL_VEHICLE_ENTRY_CREATIVE_ID,
      value,
    });
  }, []);

  useEffect(() => {
    handleBtnViewChange(checkedMethod === SELL_IT_YOURSELF);
  }, [checkedMethod, handleBtnViewChange]);

  return (
    <div className="selling-methods-wrapper pt-1_5 px-1 px-md-1_5">
      <div className="text-cool-gray-30 fw-bold mb-0_5">
        Selling Method <span className="fw-normal size-14">(optional)</span>
      </div>

      <RadioList
        disableAutoComplete
        key="selling-methods-list"
        id="selling-methods-list"
        onChange={handleChange}
        list={SELLING_METHODS}
        checked={checkedMethod}
        name="sellingMethodsList"
        formClassName="d-flex flex-column flex-md-row mt-0_75 mb-0_25"
        formGroupClassName="mb-1_25 me-md-1_5"
        labelContainerClassName="mb-0 ps-2 py-0_25"
        labelCheckedClassName="method-selected"
        labelUncheckedClassName="method-unselected"
        checkmarkClassName="mx-0_5"
        textClassName="text-cool-gray-50 size-14"
        tag="div"
      />
      <hr className="m-0" />
    </div>
  );
}

SellingMethodsModule.propTypes = {
  handleBtnViewChange: PropTypes.func,
};
